"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var link_entity_util_1 = require("../util/link-entity-util");
var link_commit_button_1 = require("./link-commit-button");
var link_remove_button_1 = require("./link-remove-button");
var link_url_input_1 = require("./link-url-input");
var LinkSubMenu = /** @class */ (function (_super) {
    __extends(LinkSubMenu, _super);
    function LinkSubMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputValue: ''
        };
        _this.handleInputChange = function (e) {
            _this.setState({
                inputValue: e.currentTarget.value
            });
        };
        _this.handleCommitClick = function () {
            var _a = _this.props, onPickerClose = _a.onPickerClose, setEditorState = _a.setEditorState, getEditorState = _a.getEditorState, requestEditorFocus = _a.requestEditorFocus;
            if (setEditorState && getEditorState) {
                setEditorState(link_entity_util_1.createOrUpdateLinkEntity(getEditorState(), _this.state.inputValue));
            }
            onPickerClose && onPickerClose();
            setTimeout(function () { return requestEditorFocus && requestEditorFocus(); }, 100);
        };
        _this.handleRemoveClick = function () {
            var _a = _this.props, onPickerClose = _a.onPickerClose, setEditorState = _a.setEditorState, getEditorState = _a.getEditorState, requestEditorFocus = _a.requestEditorFocus;
            if (setEditorState && getEditorState) {
                setEditorState(link_entity_util_1.removeLinkEntity(getEditorState()));
            }
            onPickerClose && onPickerClose();
            setTimeout(function () { return requestEditorFocus && requestEditorFocus(); }, 100);
        };
        _this.handleKeyboardInputDismiss = function () {
            var _a = _this.props, onPickerClose = _a.onPickerClose, requestEditorFocus = _a.requestEditorFocus;
            onPickerClose && onPickerClose();
            requestEditorFocus && requestEditorFocus();
        };
        return _this;
    }
    LinkSubMenu.prototype.componentDidMount = function () {
        var getEditorState = this.props.getEditorState;
        if (getEditorState) {
            var url = link_entity_util_1.getCurrentEntityLinkUrl(getEditorState()) || '';
            this.setState({
                inputValue: url
            });
        }
    };
    LinkSubMenu.prototype.render = function () {
        var _a = this.props, urlInputTheme = _a.urlInputTheme, inputPlaceholder = _a.inputPlaceholder, wrapperComponent = _a.wrapperComponent, inputComponent = _a.inputComponent, rest = __rest(_a, ["urlInputTheme", "inputPlaceholder", "wrapperComponent", "inputComponent"]);
        return (React.createElement("span", null,
            React.createElement(link_url_input_1.default, { value: this.state.inputValue, onChange: this.handleInputChange, onConfirm: this.handleCommitClick, onDismiss: this.handleKeyboardInputDismiss, placeholder: inputPlaceholder, theme: urlInputTheme, wrapperComponent: wrapperComponent, inputComponent: inputComponent }),
            React.createElement(link_commit_button_1.default, __assign({ isDisabled: !this.state.inputValue, onClick: this.handleCommitClick }, rest)),
            React.createElement(link_remove_button_1.default, __assign({ onClick: this.handleRemoveClick }, rest))));
    };
    return LinkSubMenu;
}(React.Component));
exports.default = LinkSubMenu;
